var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1001 9.62403C13.0836 9.60695 11.7575 8.58655 11.7575 8.58655C11.4392 8.28344 11.0164 8.1147 10.5769 8.11542C10.1374 8.11614 9.71511 8.28626 9.39784 8.5904L8.35107 9.47527C7.49331 9.12081 6.71408 8.60026 6.05819 7.94357C5.40231 7.28687 4.8827 6.50698 4.52926 5.64875L5.41075 4.60189C5.71423 4.28454 5.88384 3.86248 5.88435 3.42336C5.88487 2.98423 5.71625 2.56178 5.4135 2.24372C5.4135 2.24372 4.39428 0.919725 4.37665 0.902644C4.06251 0.585743 3.6362 0.405338 3.19002 0.400491C2.74385 0.395644 2.31372 0.566746 1.99277 0.876749L1.35975 1.42772C-2.89399 5.95068 8.08111 16.9316 12.5988 12.6125L13.1012 12.034C13.4195 11.7138 13.598 11.2806 13.5978 10.8291C13.5976 10.3776 13.4187 9.94395 13.1001 9.62403Z",
    fill: "#2F4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.a08afbc26b1ed914468e5529c96a3a76.svg";
export { ForwardRef as ReactComponent };